import { ComponentType, FC, useMemo } from 'react'
import { FilterCriteriaValueFieldProps } from './FilterCriteriaValueFieldProps'
import { Box, Stack } from '@mui/material'

export interface FilterCriteriaValueBetweenProps extends FilterCriteriaValueFieldProps {
  FieldComponent: ComponentType<FilterCriteriaValueFieldProps>
}

const valueFrom = (event: any) => {
  if (event?.target?.value) {
    return event.target.value as string
  } else {
    return event as string
  }
}

export const FilterCriteriaValueBetween: FC<FilterCriteriaValueBetweenProps> = ({
  assumption,
  operator,
  fieldProps: { value, onChange, disabled, ...fieldProps },
  FieldComponent,
}) => {
  const [field1Value, field2Value] = useMemo<[string, string]>(() => {
    try {
      return JSON.parse(value)
    } catch {
      return ['', '']
    }
  }, [value])

  const handleField1Change = (event: any) => {
    const newValue = valueFrom(event)
    const newValueStringified = JSON.stringify([newValue, field2Value])
    onChange(newValueStringified)
  }

  const handleField2Change = (event: any) => {
    const newValue = valueFrom(event)
    const newValueStringified = JSON.stringify([field1Value, newValue])
    onChange(newValueStringified)
  }

  return (
    <Stack direction="row" {...fieldProps} sx={{ alignItems: 'center' }}>
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <FieldComponent
          assumption={assumption}
          operator={operator}
          // @ts-expect-error each part of the field does not need all field props
          fieldProps={{ disabled, value: field1Value, onChange: handleField1Change }}
        />
      </Box>
      <Box component="span" sx={{ mx: 1, userSelect: 'none' }}>
        -
      </Box>
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <FieldComponent
          assumption={assumption}
          operator={operator}
          // @ts-expect-error each part of the field does not need all field props
          fieldProps={{ disabled, value: field2Value, onChange: handleField2Change }}
        />
      </Box>
    </Stack>
  )
}
